<ul class="breadcrumb breadcrumb-page">
  <li><a href="#">{{'app.Home' | translate}}</a></li>
  <li class="active">{{'pageHeader.userTargetRequestApprovalLevels' | translate}}</li>
</ul>

<div class="page-header">
  <div class="row">
    <h1 class="col-xs-12 col-sm-4 text-center text-left-sm"><img [src]="logo" class="img-icon" />&nbsp;&nbsp;{{'pageHeader.userTargetRequestApprovalLevels' | translate}}</h1>
  </div>
</div>


<crm-edit-user-target-request-approval-users *ngIf="editMode" (closeEvent)="closeAdding($event)" [selectedLevel]="selectedLevel"></crm-edit-user-target-request-approval-users>

<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'pageHeader.userTargetRequestApprovalLevels' | translate}} {{'Search Result' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-12">

          <p-table #dt [value]="levels" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize">
            <ng-template pTemplate="header">
              <tr>
                <th style="text-align:center" class="table-edit">
                  {{'app.type' |translate}}
                </th>
                <th width="10%" style="text-align:center" class="table-edit">{{'app.edit' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-level>
              <tr *ngIf="levels.length>0 && displayMode==2">
                <td>{{ getTypeName(level.type) }}</td>
                <td>
                  <a class="" href="javascript:;" (click)="gotoEdit(level)"><i class="fa fa-edit fa-lg font-size-20"></i></a>
                </td>
              </tr>
            </ng-template>
          </p-table>



        </div>

      </div>
    </div>
  </div>
</div>
